import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AddProductToBundleForm";
import {LIST_PRODUCTS} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelRemoveProductFromBundle} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";

function filterProducts(products) {
  return products.filter(x => x.get("type") !== "bundle");
}

function formatProducts(products) {
  return filterProducts(fromJS(products)).map((x) => {
    return x.set("title", `${x.get("sku")} ${x.get("title")}`);
  })
}

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "product_sku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

class RemoveProductFromBundleContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.removeProductFromBundle(values.set("sku", this.props.sku).toJS())
      .then((response) => {
        if (response.data.removeProductFromBundle.errors.length <= 0) {
          this.props.cancelRemoveProductFromBundle();
        } else {
          let errors = createValidationErrors(response.data.removeProductFromBundle.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRemoveProductFromBundle();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let formattedProducts = formatProducts(data.products)
    return (
      <Form
        products={formattedProducts}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CREATE_PRODUCT_BUNDLE = gql`
  mutation removeProductFromBundle($data: ProductBundleInput!) {
    removeProductFromBundle(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(LIST_PRODUCTS, {
    options: {
      fetchPolicy: "network-only"
    }    
  }),
  graphql(CREATE_PRODUCT_BUNDLE, {
    props: ({ mutate }) => ({
      removeProductFromBundle: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const RemoveProductFromBundleContainerWithData = withProductQuery(RemoveProductFromBundleContainer);

export default connect(null, {cancelRemoveProductFromBundle})(RemoveProductFromBundleContainerWithData);